import { Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { EntityrecordApi, EntityApi } from '../../../sdk/services/custom';
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../../../sdk/models';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { Observable } from 'rxjs/Rx';
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from 'ng-formly';
import * as _ from "lodash";
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'entity-display-widget',
    templateUrl: './entity-display.component.html',
    providers: [EntityrecordApi, EntityApi],
    styleUrls: ['./entity-display.component.scss']
})

export class EntityDisplayWidgetComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() entityrecordid: string;
    @Input() parentId: string;
    @Input() title = '';
    addrecord = false;
    dataelement: any;
    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    entityResponse = {};
    entity: Entity = new Entity();
    entityRecord: Entityrecord = new Entityrecord();
    fullEntityRecord: Entityrecord = new Entityrecord();
    entityDataFields: Array<Entityfield> = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    entityrecordtitle = '';
    entityRecordState = '';
    subscriptions: any = [];
    form: FormGroup;
    formEntityFields: any = [];
    formEntityRecord: Entityrecord = new Entityrecord();
    @ViewChild('editModal') public editModal: ModalDirective;
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(private _EntityrecordApi: EntityrecordApi, private _EntityApi: EntityApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _LoopBackAuth: LoopBackAuth, private fb: FormBuilder) {

    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.getEntityRecord();
    }

    private getEntityRecord(): void {
        let queries = [];
        if (this.entityrecordid) {
            queries.push(this._EntityrecordApi.findByIdProcessed(this.entityrecordid).map((res: Entityrecord) => res));
        } else if (this.parentId) {
            let filter = { 'where': { 'entityId': this.entityid, 'data.parentId': this.parentId }, 'limit': 1 };
            queries.push(this._EntityrecordApi.find(filter)
                .mergeMap(records => {
                    if (records && records.length === 1 && records[0]['id']) {
                        return this._EntityrecordApi.findByIdProcessed(records[0]['id']).map((res: Entityrecord) => res);
                    } else {
                        return Observable.of(null);
                    }
                }));
        } else {
            queries.push(Observable.of(null));
        }
        queries.push(this._EntityApi.getEntityDetails(this.entityid).map((res: any) => res));
        this.subscriptions.push(Observable.forkJoin(
            queries)
            .subscribe((data) => {
                this.entityRecordState = null;
                if (data[0]) { this.entityRecord = _.cloneDeep(data[0]['response']); }
                this.entityResponse = _.cloneDeep(data[1]);
                this.entityRecord.appId = this.currentuser.appId;
                this.entity = this.entityResponse['entity'];
                this.entityDataFields = this.entityResponse['datafields'];
                this.entityFormFields = this.entityResponse['formfields'];
                if (this.entityRecord && this.entityRecord.data) {
                    this.addrecord = false;
                    this.entityrecordid = this.entityRecord.id;
                    this.parentId = this.entityRecord.data.parentId;
                    this.entityrecordtitle = this.entityRecord.data[this.entity.record_name];
                } else { this.addrecord = true; }
            }, err => this.entityRecordState = err.message));
        this.entityResponse = {};
    }

    ngOnDestroy() {
        for (let i = 0; i < this.subscriptions.length; i++) { this.subscriptions[i].unsubscribe(); }
    }

    onChanged(entityrecord: Entityrecord): void {
        this.entityRecord = entityrecord;
        this.entityrecordid = entityrecord.id;
        this.entityid = entityrecord.entityId;
    }

    protected notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/entity-display/entity-display.component.ts